import React from "react";

function AnchorChip({ href, label }) {
  return (
    <a
      href={href}
      className="px-3 py-1.5 rounded-full text-sm bg-white text-slate-700 ring-1 ring-slate-200 hover:bg-slate-50 transition"
    >
      {label}
    </a>
  );
}

export default function QuickNav() {
  return (
    <nav
      aria-label="Sommaire"
      className="mb-6 rounded-2xl ring-1 ring-slate-200/70 bg-white/80 backdrop-blur p-3"
    >
      <ul className="flex flex-wrap gap-2">
        <li>
          <AnchorChip href="#profil" label="Coordonnées" />
        </li>
        <li>
          <AnchorChip href="#fiche" label="Événement" />
        </li>
        <li>
          <AnchorChip href="#meta" label="Infos fiche" />
        </li>
        <li>
          <AnchorChip href="#indemnites" label="Indemnités" />
        </li>
        <li>
          <AnchorChip href="#frais" label="Frais" />
        </li>
        <li>
          <AnchorChip href="#justificatifs" label="Justificatifs" />
        </li>
        <li>
          <AnchorChip href="#recap" label="Récap" />
        </li>
      </ul>
    </nav>
  );
}
